import './Styles/Loading.css';

export default function Loading(){

    return(
        <div className='loadingContent'>
            <h2>Loading...</h2>
        </div>
    );
}